import React from 'react';
import { Container, Button, Message, Divider, Segment, Grid} from 'semantic-ui-react'
import Input from '../UI/Input/Input'
import * as actions from '../../actions/index';
import { connect } from 'react-redux'
import ReactGA from 'react-ga';


class Register extends React.Component {

  componentDidMount(){
     ReactGA.ga('send', 'pageview', '/registration');
     this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_date);
  }

  componentWillUnmount(){
    actions.clearResultDetailsState();
  }

  state = {
        controls: {
            name1: {
                elementtype: 'input',
                elementconfig: {
                    type: 'text',
                    placeholder: 'Player 1 E.g Jane Doe'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
            name2: {
                elementtype: 'input',
                elementconfig: {
                    type: 'text',
                    placeholder: 'Player 2'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
            name3: {
                elementtype: 'input',
                elementconfig: {
                    type: 'text',
                    placeholder: 'Player 3'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: true,
                touched: true,
            },
            name4: {
                elementtype: 'input',
                elementconfig: {
                    type: 'text',
                    placeholder: 'Player 4'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: true,
                touched: true,
            },
        },
        formIsValid: false
  }
  
  checkValidity(value, rules){
      let isValid = true;
      const {required, minLength} = rules;

      if(required){
          isValid = value.trim() !== ''  && isValid;
      }
      if(minLength){
        isValid = value.length >= minLength && isValid;
    }
      return isValid;   
  }

  inputChangedHandler = (event, formElementId) => {
    const updatedControlsForm = {...this.state.controls};
    const updatedFormElement = {...updatedControlsForm[formElementId]};
    
    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,updatedFormElement.validation);
    updatedFormElement.touched = true;
    updatedControlsForm[formElementId] =updatedFormElement;


    let formIsValid = true;
    for (let inputIdentifiers in updatedControlsForm){
        formIsValid = updatedControlsForm[inputIdentifiers].valid && formIsValid
    }

    this.setState({controls: updatedControlsForm, formIsValid: formIsValid})
  }

  renderImage = () => {
    if(this.props.edits.editEvent.event_img === 'available after competition'){
      return <img alt={this.props.edits.editEvent.event_name} src="/images/wireframe/black-logo.png" className="ui fluid large image centered" /> 
    }
    else{
      return <img alt={this.props.edits.editEvent.event_name} src={this.props.edits.editEvent.event_img} className="ui fluid large image centered" />
    }
  }

  controlsHandler = (event) => {
      event.preventDefault();
      
      const {controls:{name1, name2, name3, name4}} = this.state;
      let player3 = name3.value
      let player4 = name4.value

      if(player3 && (!player4 || player4.length===0)){
            console.log("Three player registration not allowed")
            return;
      }
     
      const regData = {
        player1: name1.value,
        player2: name2.value,
        player3: (name3.value) ? name3.value : " ",
        player4: (name4.value) ? name4.value: " ",
        event: this.props.edits.editEvent
      }

    this.props.onReg(regData);
  }

  render ()
  {

    let errorMessage = null;

    if(this.props.error){
        errorMessage = (
            <Message negative>
                <Message.Header>Registration Error</Message.Header>
                <p>{this.props.error.message}</p>
            </Message>
            
        )
    }

    const formElementsArray = [];
    for (let key in this.state.controls) {
        formElementsArray.push({
            id: key,
            config: this.state.controls[key]
        });
    }

    const form = formElementsArray.map(formElement => (
        <Input
            key={formElement.id}
            elementtype={formElement.config.elementtype}
            elementconfig={formElement.config.elementconfig}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldvalidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={(event)=>this.inputChangedHandler(event, formElement.id)}
        />
    ))
  
    if(!this.props.edits.editEvent){
        return (
            <div className="ui container">
            <h2>Upload Results</h2>
            Loading..          
            </div>
        );
        }

    const list = [
    'For team entries: Please enter player names in each of the 4 text boxes below.',
    'For pairs entries: Please enter player names in boxes marked Player 1 and Player 2 only.'
    ]

    return <React.Fragment>
            <Container>
                <Divider hidden/>
                <h3><span> <h2>{this.props.edits.editEvent.event_name} | {this.props.edits.editEvent.event_day}-{this.props.edits.editEvent.event_month}-{this.props.edits.editEvent.event_year}</h2><br/>
                 </span></h3>
                 <Divider hidden/>
                 <Segment basic>
                    <Grid columns={2} stackable textAlign='center'>
                        <Grid.Row >
                            <Grid.Column>
                                <Message header='Game Registration Instructions' list={list} />
                                {errorMessage}
                                <form onSubmit={this.controlsHandler}>
                                    {form}<br/>
                                    <Button className="ui button primary" disabled={!this.state.formIsValid}>Register Players</Button>
                                </form>
                            </Grid.Column>
                            <Grid.Column>
                                {this.renderImage()}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                 </Segment>
             </Container>
        </React.Fragment>
    }
};

const mapStatetoProps = state => {
    return {
        error: state.auth.error,
        edits: state.edits,
    }   
}

const mapDispatchToProps = dispatch => {
    return {
        onReg: (regData) => dispatch(actions.reg(regData)),
        fetchEvent: (eventId, eventDate) => dispatch(actions.fetchEvent(eventId, eventDate))
    }
};

export default connect(mapStatetoProps, mapDispatchToProps)(Register);
